import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SUPPORTED_LOCALES, UnitsStore } from '@store';
import { FeatureConnectionService } from '../../../../shared/services/feature-connection.service';

import { NO_VALUE } from '../../../../shared/pipes';
import { convertToFahrenheitRounded } from '../../converter/converter';
import { isNumber } from '../../../../@store/_common/number-type-helpers';
import { DecimalPipeWrapper } from '../../../../shared/pipes/decimal-pipe-wrapper/decimal-pipe-wrapper.pipe';
import { SUFFIX } from '../../../../shared/common/units';

/**
 * @deprecated To be replaced with number-value-temperature-strategy
 */
@Pipe({
  name: 'temperatureUnit',
})
export class TemperatureUnitPipe implements PipeTransform, OnDestroy {
  isCelsius: boolean;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private featureConnectionService: FeatureConnectionService,
    private unitsStore: UnitsStore,
    private decimalPipeWrapper: DecimalPipeWrapper
  ) {
    this.unitsStore.isTemperatureMetric$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isCelsius) => (this.isCelsius = isCelsius));
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  transform(val: any): any {
    if (
      this.featureConnectionService.isErrorOrNotConnectedBasedOnValue(val) ||
      this.featureConnectionService.isErrorOrNotConnectedBasedOnTranslation(val)
    ) {
      return val;
    }

    if (val === NO_VALUE) {
      return val;
    }

    if (val !== null && val !== undefined) {
      let localizedValue: string;
      if (isNumber(val)) {
        localizedValue = this.decimalPipeWrapper.transform(val);
      } else {
        localizedValue = val;
      }

      return this.convertedTemperature(localizedValue);
    }

    return NO_VALUE;
  }

  convertedTemperature(val: any): string {
    let temperature: string;

    switch (this.isCelsius) {
      case true:
        temperature = val + SUFFIX.celsius;
        break;
      case false:
      default:
        // VIG-12075 in case of the comma as the decimal separator, we need to convert the value to an international locale
        val = Number(this.decimalPipeWrapper.transform(val, null, SUPPORTED_LOCALES.en));
        temperature = convertToFahrenheitRounded(val) + SUFFIX.fahrenheit;
        break;
    }

    return temperature;
  }
}
